import { DescribeNodeType } from '~/scenes/Automation/Flows/Actions/util/descriptionStandards';

const describeAppVBOWaardecheckContactRequestNewCondition =
  (): DescribeNodeType =>
    'een nieuw Avix Waardecheck contactverzoek is opgevraagd';

export default describeAppVBOWaardecheckContactRequestNewCondition;
